// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: /opt/dev_environment/assets/workspace/app-init/src/components/DataExportSection/DataExportSection.css */

.data-export-section {
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  padding: var(--space-lg);
  box-shadow: var(--shadow-md);
}

.data-export-section__title {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin-bottom: var(--space-xs);
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.data-export-section__title-icon {
  font-size: var(--font-size-lg);
}

.data-export-section__description {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  line-height: var(--line-height-normal);
  margin-bottom: var(--space-md);
}

.data-export-section__buttons {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}

.data-export-btn {
  width: 100%;
  padding: var(--space-md);
  border-radius: var(--radius-md);
  border: 1.5px solid var(--color-border);
  background-color: var(--color-card-white);
  color: var(--color-text-primary);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
  font-family: inherit;
}

.data-export-btn:hover:not(:disabled) {
  background-color: var(--color-progress-bg);
  border-color: var(--color-wood-medium);
}

.data-export-btn:active:not(:disabled) {
  background-color: var(--color-border);
  transform: scale(0.98);
}

.data-export-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.data-export-btn--primary {
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
  border-color: var(--color-wood-medium);
  box-shadow: var(--shadow-sm);
}

.data-export-btn--primary:hover:not(:disabled) {
  background-color: var(--color-wood-dark);
  border-color: var(--color-wood-dark);
}

.data-export-btn--primary:active:not(:disabled) {
  background-color: var(--color-wood-dark);
}

.data-export-btn__icon {
  font-size: var(--font-size-lg);
  line-height: 1;
}

.data-export-btn__loading {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: export-spin 0.6s linear infinite;
}

@keyframes export-spin {
  to { transform: rotate(360deg); }
}

/* ---- Email Dialog ---- */
.data-export-email-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-md);
  animation: overlay-fade-in 0.2s ease-out;
}

.data-export-email-dialog {
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-width: 360px;
  padding: var(--space-lg);
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  animation: dialog-slide-up 0.25s ease-out;
}

.data-export-email-dialog__icon {
  font-size: 2.5rem;
  text-align: center;
  line-height: 1;
}

.data-export-email-dialog__title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  text-align: center;
}

.data-export-email-dialog__description {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  text-align: center;
  line-height: var(--line-height-normal);
}

.data-export-email-dialog__input-group {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
}

.data-export-email-dialog__label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-secondary);
}

.data-export-email-dialog__input {
  padding: var(--space-sm) var(--space-md);
  border: 1.5px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  background-color: var(--color-card-white);
  transition: border-color var(--transition-fast);
  appearance: none;
  font-family: inherit;
}

.data-export-email-dialog__input:focus {
  outline: none;
  border-color: var(--color-wood-medium);
  box-shadow: 0 0 0 3px rgba(139, 94, 60, 0.15);
}

.data-export-email-dialog__input::placeholder {
  color: var(--color-text-light);
}

.data-export-email-dialog__input--error {
  border-color: var(--color-error);
}

.data-export-email-dialog__error {
  font-size: var(--font-size-xs);
  color: var(--color-error);
  font-weight: var(--font-weight-semibold);
}

.data-export-email-dialog__actions {
  display: flex;
  gap: var(--space-sm);
  padding-top: var(--space-xs);
}

.data-export-email-dialog__btn {
  flex: 1 1;
  padding: var(--space-md);
  border-radius: var(--radius-md);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  border: none;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-xs);
}

.data-export-email-dialog__btn--cancel {
  background-color: var(--color-progress-bg);
  color: var(--color-text-secondary);
}

.data-export-email-dialog__btn--cancel:active {
  background-color: var(--color-border);
}

.data-export-email-dialog__btn--send {
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
  box-shadow: var(--shadow-sm);
}

.data-export-email-dialog__btn--send:active:not(:disabled) {
  background-color: var(--color-wood-dark);
}

.data-export-email-dialog__btn--send:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ---- Toast Messages ---- */
.data-export-toast {
  margin-top: var(--space-sm);
  padding: var(--space-sm) var(--space-md);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  text-align: center;
  animation: export-toast-fade 4s ease-out forwards;
}

.data-export-toast--success {
  background-color: rgba(76, 175, 80, 0.1);
  border: 1.5px solid var(--color-success);
  color: var(--color-success);
}

.data-export-toast--error {
  background-color: rgba(229, 57, 53, 0.1);
  border: 1.5px solid var(--color-error);
  color: var(--color-error);
}

@keyframes export-toast-fade {
  0% { opacity: 0; transform: translateY(4px); }
  10% { opacity: 1; transform: translateY(0); }
  80% { opacity: 1; }
  100% { opacity: 0; }
}`, "",{"version":3,"sources":["webpack://./src/components/DataExportSection/DataExportSection.css"],"names":[],"mappings":"AAAA,gHAAgH;;AAEhH;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;EAChC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,+BAA+B;EAC/B,uCAAuC;EACvC,yCAAyC;EACzC,gCAAgC;EAChC,gCAAgC;EAChC,wCAAwC;EACxC,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,yCAAyC;EACzC,+CAA+C;EAE/C,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,wBAAwB;EACxB,+BAA+B;EAC/B,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;EACf,YAAY;EACZ,sCAAsC;EACtC,wCAAwC;EACxC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,+BAA+B;EAC/B,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,KAAK,UAAU,EAAE,0BAA0B,EAAE;EAC7C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB","sourcesContent":["/* File: /opt/dev_environment/assets/workspace/app-init/src/components/DataExportSection/DataExportSection.css */\n\n.data-export-section {\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  padding: var(--space-lg);\n  box-shadow: var(--shadow-md);\n}\n\n.data-export-section__title {\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n  margin-bottom: var(--space-xs);\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.data-export-section__title-icon {\n  font-size: var(--font-size-lg);\n}\n\n.data-export-section__description {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n  line-height: var(--line-height-normal);\n  margin-bottom: var(--space-md);\n}\n\n.data-export-section__buttons {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-sm);\n}\n\n.data-export-btn {\n  width: 100%;\n  padding: var(--space-md);\n  border-radius: var(--radius-md);\n  border: 1.5px solid var(--color-border);\n  background-color: var(--color-card-white);\n  color: var(--color-text-primary);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-sm);\n  font-family: inherit;\n}\n\n.data-export-btn:hover:not(:disabled) {\n  background-color: var(--color-progress-bg);\n  border-color: var(--color-wood-medium);\n}\n\n.data-export-btn:active:not(:disabled) {\n  background-color: var(--color-border);\n  transform: scale(0.98);\n}\n\n.data-export-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.data-export-btn--primary {\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n  border-color: var(--color-wood-medium);\n  box-shadow: var(--shadow-sm);\n}\n\n.data-export-btn--primary:hover:not(:disabled) {\n  background-color: var(--color-wood-dark);\n  border-color: var(--color-wood-dark);\n}\n\n.data-export-btn--primary:active:not(:disabled) {\n  background-color: var(--color-wood-dark);\n}\n\n.data-export-btn__icon {\n  font-size: var(--font-size-lg);\n  line-height: 1;\n}\n\n.data-export-btn__loading {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid currentColor;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: export-spin 0.6s linear infinite;\n}\n\n@keyframes export-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ---- Email Dialog ---- */\n.data-export-email-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 200;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-md);\n  animation: overlay-fade-in 0.2s ease-out;\n}\n\n.data-export-email-dialog {\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  width: 100%;\n  max-width: 360px;\n  padding: var(--space-lg);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n  animation: dialog-slide-up 0.25s ease-out;\n}\n\n.data-export-email-dialog__icon {\n  font-size: 2.5rem;\n  text-align: center;\n  line-height: 1;\n}\n\n.data-export-email-dialog__title {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n  text-align: center;\n}\n\n.data-export-email-dialog__description {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n  text-align: center;\n  line-height: var(--line-height-normal);\n}\n\n.data-export-email-dialog__input-group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xs);\n}\n\n.data-export-email-dialog__label {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-secondary);\n}\n\n.data-export-email-dialog__input {\n  padding: var(--space-sm) var(--space-md);\n  border: 1.5px solid var(--color-border);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-base);\n  color: var(--color-text-primary);\n  background-color: var(--color-card-white);\n  transition: border-color var(--transition-fast);\n  -webkit-appearance: none;\n  appearance: none;\n  font-family: inherit;\n}\n\n.data-export-email-dialog__input:focus {\n  outline: none;\n  border-color: var(--color-wood-medium);\n  box-shadow: 0 0 0 3px rgba(139, 94, 60, 0.15);\n}\n\n.data-export-email-dialog__input::placeholder {\n  color: var(--color-text-light);\n}\n\n.data-export-email-dialog__input--error {\n  border-color: var(--color-error);\n}\n\n.data-export-email-dialog__error {\n  font-size: var(--font-size-xs);\n  color: var(--color-error);\n  font-weight: var(--font-weight-semibold);\n}\n\n.data-export-email-dialog__actions {\n  display: flex;\n  gap: var(--space-sm);\n  padding-top: var(--space-xs);\n}\n\n.data-export-email-dialog__btn {\n  flex: 1;\n  padding: var(--space-md);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-bold);\n  cursor: pointer;\n  border: none;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  font-family: inherit;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-xs);\n}\n\n.data-export-email-dialog__btn--cancel {\n  background-color: var(--color-progress-bg);\n  color: var(--color-text-secondary);\n}\n\n.data-export-email-dialog__btn--cancel:active {\n  background-color: var(--color-border);\n}\n\n.data-export-email-dialog__btn--send {\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n  box-shadow: var(--shadow-sm);\n}\n\n.data-export-email-dialog__btn--send:active:not(:disabled) {\n  background-color: var(--color-wood-dark);\n}\n\n.data-export-email-dialog__btn--send:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ---- Toast Messages ---- */\n.data-export-toast {\n  margin-top: var(--space-sm);\n  padding: var(--space-sm) var(--space-md);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  text-align: center;\n  animation: export-toast-fade 4s ease-out forwards;\n}\n\n.data-export-toast--success {\n  background-color: rgba(76, 175, 80, 0.1);\n  border: 1.5px solid var(--color-success);\n  color: var(--color-success);\n}\n\n.data-export-toast--error {\n  background-color: rgba(229, 57, 53, 0.1);\n  border: 1.5px solid var(--color-error);\n  color: var(--color-error);\n}\n\n@keyframes export-toast-fade {\n  0% { opacity: 0; transform: translateY(4px); }\n  10% { opacity: 1; transform: translateY(0); }\n  80% { opacity: 1; }\n  100% { opacity: 0; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
